import { EditProfile } from '@unistocks/features/settings/edit-profile';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function AdminEditProfileScreen() {
  return (
    <>
      <Head>
        <title>{t('AbpAccount::ProfileTab:PersonalInfo')}</title>
      </Head>
      <EditProfile />
    </>
  );
}
